import React from 'react';

import { LoadingOutlined } from '@ant-design/icons';
import styled from '@emotion/styled';

interface CompanyInformationProps {
  roleName: string;
  vehicleTypes: string[];
  totalLookupInitiated: number;
  loading: boolean;
}

const CompanyInformation: React.FC<CompanyInformationProps> = ({
  roleName,
  vehicleTypes,
  totalLookupInitiated,
  loading,
}) => {
  if (loading) {
    return <LoadingOutlined />;
  }

  return (
    <Container>
      <Label>Company Information</Label>
      <GrayArea>
        <Row>
          <div>User role name</div>
          <BoldText>{roleName}</BoldText>
        </Row>
        <Row>
          <div>Category of listed fleets</div>
          <BoldText>
            {vehicleTypes.map((type, index) => (
              <Cell key={index}>{type}</Cell>
            ))}
          </BoldText>
        </Row>
        <Row>
          <div>Look up count</div>
          <BoldText>{totalLookupInitiated}</BoldText>
        </Row>
      </GrayArea>
    </Container>
  );
};

export default CompanyInformation;

const Container = styled.div`
  padding: 12px 24px;
  border-radius: 8px;
  border: 1px solid ${({ theme }) => theme.palette.borderColor};
`;

const Label = styled.div`
  font-size: 16px;
  font-weight: 600;
  margin-bottom: 12px;
  line-height: 30px;
`;

const GrayArea = styled.div`
  width: 100%;
  padding: 12px;
  color: #fafafa;
  display: flex;
  flex-direction: column;
  gap: 16px;

  background-color: #fafafa;
`;

const Row = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 16px;
  font-weight: 500;
  font-size: 14px;
  line-height: 14px;
  color: #6e7079;
`;

const BoldText = styled.div`
  font-weight: 600;
  font-size: 14px;
  line-height: 14px;
  text-align: right;
  color: #2f3644;

  display: flex;
  gap: 4px;
`;

const Cell = styled.div`
  border: 1px solid ${({ theme }) => theme.palette.borderColor};
  padding: 5.5px 12px;
  border-radius: 4px;
`;
